import React from 'react';
import { useTranslation } from 'react-i18next';

import type { AssistantMessage } from '../types';

/* Right-aligned user bubble. Queued messages render at reduced opacity with a tag. */
const UserBubble = ({ message }: { message: AssistantMessage }) => {
  const { t } = useTranslation('assistant');
  // Don't render an empty bubble (e.g. an answer with no echo text).
  if (!message.content && !message.queued) return null;
  return (
    <div className={`bra-msg bra-u${message.queued ? ' bra-queued' : ''}`}>
      <div className="bra-bub">{message.content}</div>
      {message.queued ? (
        <div className="bra-qtag">
          <span
            className="bra-spin"
            style={{ width: 9, height: 9, borderWidth: 1.5 }}
          />
          {t('Queued — will send when the current turn finishes')}
        </div>
      ) : null}
    </div>
  );
};

export default UserBubble;
